

































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import GiftInfo from '@/store/entities/gift-info';
import dayjs from "dayjs";
import GiftPackage from "@/store/entities/gift-package";
import Campaign from "@/store/entities/campaign";


@Component
export default class CreateGiftInfo extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  giftInfo: GiftInfo = new GiftInfo();

  get loading() {
    return this.$store.state.giftInfo.loading;
  }

  save() {
    (this.$refs.giftInfoForm as any).validate(async (valid: boolean) => {
      if (valid) {

        let m = this.$store.state.main.campaign as Campaign;

        if (!m) {
          this.$Message.error('请选择活动');
          return;
        }

        this.giftInfo.campaignCode = m.campaignCode;
        this.giftInfo.campaignId = m.id;
        await this.$store.dispatch({
          type: 'giftInfo/create',
          data: this.giftInfo
        });
        (this.$refs.giftInfoForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    })
  }

  cancel() {
    (this.$refs.giftInfoForm as any).resetFields();
    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    }
  }

  giftInfoRule = {
    giftName: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('giftName')),
      trigger: 'blur'
    }],
    giftCode: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('giftCode')),
      trigger: 'blur'
    }]
  }
}
